module.exports = __webpack_public_path__ + "static/media/glowna_foto_new.c64a638e.jpg";